import { useQuery } from '@tanstack/react-query'

import { Summary } from '../types'
import { useApi } from '../api'
import { stripDailySummaryTitle } from '../utils/stringUtils'

export function useSummaryById(id: string) {
  const { get } = useApi()

  return useQuery<Summary, Error>({
    queryKey: [`summaries/${id}`],
    queryFn: async () => {
      const resp = await get(`summaries/${id}`, { version: 'v1' })
      if (!resp.ok) {
        throw new Error(resp.statusText ?? `Unexpected ${resp.status} error`)
      }
      const json = await resp.json()
      if (!json.success) {
        throw new Error('Unexpected error')
      }
      const summary = json.data as Summary
      return {
        ...summary,
        summary: stripDailySummaryTitle(summary.summary),
      }
    },
    staleTime: 30 * 60 * 1000,
  })
}
